"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardDetailsConsentBox = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const CardDetailsConsentForm = (0, _mui.styled)(_mui.FormControlLabel)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(2, 8, 2, 2)
    };
});
const CardDetailsConsentBox = (param)=>{
    let { isChecked, onChangeHandler } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardDetailsConsentForm, {
        ...getTestIdProps(_models.TestId.CardDetailsConsent),
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Checkbox, {
            checked: isChecked,
            onChange: onChangeHandler
        }),
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "iAgreeWithSavingOfMyPaymentCardDetails"
        })
    });
};
exports.CardDetailsConsentBox = CardDetailsConsentBox;
